import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import exercisesMap from './exercise-list'

@Injectable()
export class ExercisesProvider {

  EXERCSE_LIST_FILE_PATH: string = 'assets/exercises/exercise-list.json';
  HISTORY_STORAGE_KEY: string = 'exercise_history';

  loaded: boolean = false;
  exercises: any = {};

  history: any;

  constructor(
    public http: HttpClient,
    private storage: Storage
  ) {
    console.log('Hello ExercisesProvider Provider');
    this.loadHistory();
  }

  getExercise(id: string) {
    let exercise = exercisesMap[id];
    if (!exercise) {
      exercise = {
        id: 'error',
        name: 'Something went wrong'
      }
    }
    return exercise;
  }

  loadHistory() {
    this.storage.get(this.HISTORY_STORAGE_KEY).then(data => {
      if (data) {
        this.history = JSON.parse(data);
      } else {
        this.history = {};
      }
    });
  }

  updateHistory(exerciseId: string, valueToAdd: string) {

    valueToAdd = valueToAdd.trim();
    if (!valueToAdd) {
      return;
    }

    let specificHistory = [];

    // Retrieve the history for a given ID
    if (this.history[exerciseId]) {
      specificHistory = this.history[exerciseId];
    }

    // Add the new value to the specific history
    specificHistory.push({
      value: valueToAdd,
      date: new Date().toString()
    });
    this.history[exerciseId] = specificHistory;

    // Save all of the history back to storage
    this.storage.set(this.HISTORY_STORAGE_KEY, JSON.stringify(this.history));

  }

  getFullHistory(exerciseId: string) {
    if (this.history) {
      return this.history[exerciseId];
    }

  }

  getLastHistory(exerciseId: string) {
    let specificHistory = this.getFullHistory(exerciseId);
    if (!specificHistory) {
      return;
    }
    return specificHistory[specificHistory.length - 1].value;
  }

  getExportString() {
    return this.storage.get(this.HISTORY_STORAGE_KEY);
  }

}



// WEBPACK FOOTER //
// ./src/providers/exercises/exercises.ts